<section class="services" id="servicios">
  <div class="services__inner">

    <!-- Heading -->
    <div class="services__heading">
      <h2 class="services__heading-title h2">Tu espacio para crear y volver a ti.</h2>
      <p class="services__heading-text body-m">
        En Aruma, diseñamos experiencias que combinan arte, bienestar y la calma.<br>
        Un espacio para pausar el ruido exterior y reconectar con tu esencia a través de la creatividad.
      </p>
    </div>

    <!-- Cards row -->
    <div class="services__cards">
      @for (service of services; track service.title; let first = $first) {

        <article class="services__card" [class.services__card--first]="first">

          <!-- Icon 90×90 -->
          <div class="services__icon" aria-hidden="true">
            @if (service.icon === 'rombo') {
              <svg width="90" height="90" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="12.7817" y="12.332" width="6.37851" height="6.37851" stroke="var(--color-primary-500)"/>
                <rect x="9.05354" y="15.5491" width="9.82181" height="9.82181" transform="rotate(-45 9.05354 15.5491)" stroke="var(--color-primary-500)"/>
                <rect x="8.50659" y="8.42578" width="14.7408" height="14.7408" stroke="var(--color-primary-500)"/>
                <rect x="0.707107" y="16" width="21.6274" height="21.6274" transform="rotate(-45 0.707107 16)" stroke="var(--color-primary-500)"/>
              </svg>
            }
            @if (service.icon === 'circulos') {
              <svg width="90" height="94" viewBox="0 0 32 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10.6667" cy="10.6667" r="10.1667" stroke="var(--color-primary-500)"/>
                <circle cx="21.3333" cy="10.6667" r="10.1667" stroke="var(--color-primary-500)"/>
                <circle cx="10.6667" cy="22.9334" r="10.1667" stroke="var(--color-primary-500)"/>
                <circle cx="21.3333" cy="22.9334" r="10.1667" stroke="var(--color-primary-500)"/>
              </svg>
            }
            @if (service.icon === 'sol') {
              <svg width="90" height="90" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.41984 16.0314H1.65515" stroke="var(--color-primary-500)" stroke-miterlimit="10" stroke-linecap="round"/>
                <path d="M30.3978 16.0314H23.6427" stroke="var(--color-primary-500)" stroke-miterlimit="10" stroke-linecap="round"/>
                <path d="M10.6459 21.4069L5.86975 26.1927" stroke="var(--color-primary-500)" stroke-miterlimit="10" stroke-linecap="round"/>
                <path d="M26.1923 5.87012L21.4065 10.6463" stroke="var(--color-primary-500)" stroke-miterlimit="10" stroke-linecap="round"/>
                <path d="M16.0309 23.6428V30.3979" stroke="var(--color-primary-500)" stroke-miterlimit="10" stroke-linecap="round"/>
                <path d="M16.0309 1.65515V8.41986" stroke="var(--color-primary-500)" stroke-miterlimit="10" stroke-linecap="round"/>
                <path d="M21.4065 21.4069L26.1923 26.1927" stroke="var(--color-primary-500)" stroke-miterlimit="10" stroke-linecap="round"/>
                <path d="M5.86975 5.87012L10.6459 10.6463" stroke="var(--color-primary-500)" stroke-miterlimit="10" stroke-linecap="round"/>
                <circle cx="16" cy="16" r="5" stroke="var(--color-primary-500)"/>
              </svg>
            }
          </div>

          <!-- Description: info + button -->
          <div class="services__description">
            <div class="services__info">
              <h3 class="services__title">{{ service.title }}</h3>
              <p class="services__text">{{ service.description }}</p>
            </div>
            <button class="services__cta" (click)="scrollTo(service.ctaTarget)">
              {{ service.cta }}
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M7 17L17 7M17 7H9M17 7V15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>

        </article>
      }
    </div>

  </div>
</section>
